import React from 'react';
import Icon from '../../../components/AppIcon';

const HazardAssessment = ({ hazards }) => {
  const getSeverityColor = (severity) => {
    const colors = {
      'Critical': 'bg-error text-error-foreground',
      'High': 'bg-warning text-warning-foreground',
      'Medium': 'bg-accent text-accent-foreground',
      'Low': 'bg-success text-success-foreground'
    };
    return colors?.[severity] || 'bg-muted text-muted-foreground';
  };

  const getHazardIcon = (type) => {
    const icons = {
      'Electrical': 'Zap',
      'Chemical': 'Droplet',
      'Height': 'TrendingUp',
      'Mechanical': 'Settings',
      'Fire': 'Flame',
      'Confined Space': 'Box'
    };
    return icons?.[type] || 'AlertTriangle';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
        <h2 className="text-lg font-semibold text-foreground">Hazard Assessment</h2>
      </div>
      <div className="space-y-3">
        {hazards?.map((hazard) => (
          <div key={hazard?.id} className="border border-border rounded-lg p-4 hover:border-accent/50 transition-colors">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center flex-shrink-0">
                <Icon name={getHazardIcon(hazard?.type)} size={20} color="var(--color-warning)" />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-medium text-foreground">{hazard?.type}</h3>
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${getSeverityColor(hazard?.severity)}`}>
                    {hazard?.severity}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">{hazard?.description}</p>
              </div>
            </div>

            <div className="border-t border-border pt-3">
              <h4 className="text-xs font-medium text-foreground mb-2">Control Measures</h4>
              <div className="space-y-1.5">
                {hazard?.controls?.map((control, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <Icon name="Shield" size={14} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                    <span className="text-xs text-muted-foreground">{control}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HazardAssessment;